// Staging-only escape hatch: staging always runs central (needed so the YClients client/records
// proxy routes, gated requireCentralAdmin at the catalog level, keep working), but testing the
// patient-matching flow needs the real point UI (location login, Scanner tab). Set only in the
// staging frontend build (`VITE_FORCE_POINT_UI=1`), never in the prod build.
import { TEST_BUILD } from "./testBuild.js";
export const FORCE_POINT_UI = TEST_BUILD || import.meta.env.VITE_FORCE_POINT_UI === "1";
